import chunk from 'chunk'
import qr from 'qr-image'
import barcode from 'barcode-2-svg'
import moment from 'moment'

import logo from '../assets/images/logo_thai_run_B.png'

var date1 = new Date();


export const labelHeader = `
<div class="label-header">
  <div class="logo"><img src="${logo}" /></div>
  <div class="sender">
    Thaidotrun Co., Ltd.<br />
    803 โครงการ stadium One <br />
    ซอย จุฬาลงกรณ์ 4 ถนน บรรทัดทอง  <br />
    แขวง วังใหม่ เขต ปทุมวัน กรุงเทพฯ 10330
  </div>
</div>
`

export const genLabel = createLabel => (data, sponsor) => {

  const labelQrcode = label => `

<div class='flash-tracking'>
  <div class='sortCodeSection'><span class='sortCode'>${label.tracking.sortCode.split("-")[0]}-</span><span class='sortCodeBig'>${label.tracking.sortCode.split("-")[1]}</span><span class='sortCode'>-${label.tracking.sortCode.split("-")[2]}</span></div>
  ${barcode(label.tracking.code.toString(), "code128", {width:300, barWidth:300, barHeight:40})}<br />
  <div class='trackingCode'>${label.tracking.code || 'TEST000000'}</div>
</div>

<div class='flash-tracking-detail'>
  DST <span class='dstName'>${label.tracking.dstStoreName}</span>
</div>

<div class='flash-tracking-sortinglinecode'>
  ${label.tracking.sortingLineCode || ''}
</div> 

<div class='print-date'>
  Print : ${moment(date1).format("YYYY-MM-DD HH:mm:ss")}
</div> 

<div class="qrcode">
  <div class='qrcode-image'>
    ${qr.imageSync(label.tracking.code, { type: 'svg' })}
  </div>
</div>
<div class="label-id">
  (${label.data.count} ชิ้น)<br />
  ถุงที่ ${label.seq}/${label.last}
</div>
`
  const createRow = row => `
<tr>
  ${row.map(label => createLabel(label, labelQrcode)).join('\n')}
</tr>`
  const createPage = labels => `
<table style="page-break-after: always;">
  ${chunk(labels, 1).map(row => createRow(row)).join('\n')}
</table>`

  const html = `
<html>
  <style>
    @import url('https://fonts.googleapis.com/css?family=Kanit');
    body{
      margin: 0px;
      font-family: 'Kanit', sans-serif;
    }
    td {
      vertical-align: top;
      text-align: left;
      font-size: 12px;
    }
    table {
      border-collapse: collapse;
      width: 10.2cm;
    }
    .main-cell {
      max-width: 10.2cm;
      width: 10.2cm;
      max-height: 7.4cm;
      height: 7.4cm;
      position: relative;
    }
    .gap-hor td {
      width: 4.15in;
      padding: 0;
    }
    .label {
      margin: 0cm 0.3cm;
    }
    .qrcode {
      top: 191px;
      right: 14px;
      position: absolute;
      background: #fff;
      text-align: center;
      font-size: 7px;
    }

    .qrcode-image{
      width: 1.5cm;
      text-align:center;
    }

    .flash-tracking {
      top: 4px;
      right: 0.4cm;
      display: block;
      text-align: center;
      font-size: 12px;
    }

    .sortCodeSection{
      margin-bottom: -5px;
    }
    .sortCode{
      font-size: 20px;
      font-weight: 900;
    }

    .sortCodeBig{
      font-size: 28px;
      font-weight: 900;
    }

    .dstName{
      font-weight: 900;
      padding-left: 5px;
    }

    .flash-tracking-detail {
      display: block;
      background: #fff;
      text-align: left;
      font-size: 12px;
      border: 1px solid;
      padding-left: 5px;
    }

    .print-date{
      position: absolute;
      font-size: 8px;
      top: 257px;
      right: 16px;
      font-weight: 900;
    }

    .items-data{
      max-width: 260px;
    }
    .flash-tracking-sortinglinecode{
      top: 115px;
      right: 13px;
      position: absolute;
      background: #000;
      color: #fff;
      text-align: center;
      font-size: 40px;
      padding: 8px;
      font-weight: 900;
    }
    
    .label-id {
      position: absolute;
      bottom: 10px;
      right: 3.5cm;
      text-align: right;
      font-size: 9px;
      display: none;
    }
    .label-header {
      display: flex;
      margin-bottom: 0.2cm;
      border: 1px solid #000;
      font-size: 11px;
      margin-top: -1px;
    }
    .label-header .logo img {
      width: 70px;
    }
    .label-header .sender {
      font-size: 7px;
      width: 2.65in;
      height: 41px;
    }
    .recipient {
      font-size: 8px;
      font-weight: bold;
      margin-top: -1px;
      border: 1px solid;
      padding-left: 5px;
      height: 37px;
    }
    .recipient-data{
      width:260px;
    }
    .sponsor {
      position: absolute;
      bottom: 10px;
      left: 0.3cm;
      width: 5cm;
    }
    .sponsor img {
      max-width: 5cm;
      max-height: 2.5cm;
    }
    .event {
      margin-bottom: 0.2cm;
    }
    .items {
      font-size: 8px;
      padding-left:5px;
      border:1px solid;
      margin-top: -1px;
      height: 73px;
    }
  </style>
  <body>
    ${chunk(data, 1).map(page => createPage(page)).join('\n')}
  </body>
</html>
`
  return html
}

export default {
  genLabel,
}



// WEBPACK FOOTER //
// ./src/helpers/label_flash.js